// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"45b73bd8","8":"37764a7a"}[chunkId] + ".chunk.js";
};